import { useLocation } from "react-router-dom";

export const importAllFrom = (route) => route.keys().map(route);

export const redirectToCiDi = () => window.open(process.env.REACT_APP_URL_LOGIN_CIDI, '_self');

export const registrate = () => window.open(process.env.REACT_APP_REGISTRATE, '_self');

export const useQuery = () => new URLSearchParams(useLocation().search);

const hasReactNativeWebView = () =>
    typeof window.ReactNativeWebView !== 'undefined' && window.ReactNativeWebView !== null;

export const isNative = async (retries = 5, interval = 400) => {
    if (hasReactNativeWebView()) {
        return true;
    }

    for (let i = 0; i < retries; i++) {
        if (hasReactNativeWebView()) {
            return true;
        }

        await new Promise(resolve => setTimeout(resolve, interval));
    }
    return false;
};